<template>
  <div v-if="variant == 'short'">
    <NavItem
      id="extra"
      :name="$t('Menu.Groups.Extra')"
      :border="false"
      :variant="variant"
      :icon="icons.ExtraIcon"
      :hidden-tooltip="hiddenTooltip"
      tabindex="0"
    >
    </NavItem>
    <ExtraIcon />

    <ExtraPopover :title="title" :items="items" target="extra" placement="bottom" />
  </div>
</template>

<script>
  import NavItem from '../NavItem.vue';
  import ExtraPopover from './ExtraPopover.vue';

  import ExtraIcon from '@/assets/icons/extra.svg';

  const ICONS = {
    ExtraIcon
  };

  export default {
    name: 'ExtraComponent',
    components: {
      ExtraIcon,
      NavItem,
      ExtraPopover
    },
    props: {
      items: {
        type: Array,
        default() {
          return [];
        }
      },
      hiddenTooltip: { type: Boolean, default: false},
      title: { type: String },
      variant: { type: String, default: 'short' }
    },
    data() {
      return {
        icons: ICONS
      };
    }
  };
</script>
